import React from 'react';
import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

const SchedulerCollapsibleSection = ({
  title,
  subtitle,
  children,
  badge,
}) => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  const headerBg = useColorModeValue('gray.50', 'navy.900');
  const headerHoverBg = useColorModeValue('gray.100', 'navy.800');

  return (
    <AccordionItem
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="md"
      mb={2}
      overflow="hidden"
      _last={{ mb: 0 }}
    >
      <AccordionButton py={3} px={4} bg={headerBg} _hover={{ bg: headerHoverBg }}>
        <Box flex="1" textAlign="left">
          <Text fontWeight="semibold" fontSize="sm">
            {title}
          </Text>
          {subtitle && (
            <Text fontSize="xs" color="gray.500" mt={0.5}>
              {subtitle}
            </Text>
          )}
        </Box>
        {badge}
        <AccordionIcon ml={2} />
      </AccordionButton>
      <AccordionPanel px={4} py={4} bg="white">
        {children}
      </AccordionPanel>
    </AccordionItem>
  );
};

export default SchedulerCollapsibleSection;
